import { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Layout from "./pages/layout";
import Home from "./pages/routes/homepage";
import AboutUs from "./pages/routes/about_us";
import Projects from "./pages/routes/projects";
import Blogs from "./pages/routes/blog/blogs";
import ContactUs from "./pages/routes/contactus";
import ServicePage from "./pages/routes/services/service";
import SuspenseLoading from "./components/suspenseLoading";
import Careers from "./pages/routes/careers";
import NotFound from "./pages/not_found";

const BlogDetail = lazy(() => import("../src/pages/routes/blog/blogDetails"));

const PrivacyPolicy = lazy(() => import("./pages/routes/footer/privacyPolicy"));
const TermsAndConditions = lazy(
  () => import("../src/pages/routes/footer/termsAndConditions"),
);
const Imprint = lazy(() => import("../src/pages/routes/footer/imprint"));

// services Routes=======
// Telecommunications

const ServiceDetails = lazy(
  () => import("../src/pages/routes/services/details"),
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to={"/home"} />} />
          <Route path="home" element={<Home />} />
          <Route path="aboutus" element={<AboutUs />} />
          <Route path="projects" element={<Projects />} />
          <Route path="contactUs" element={<ContactUs />} />
          <Route path="careers" element={<Careers />} />
          <Route path="*" element={<NotFound />} />

          {/* //====================================================== */}
          <Route path="services">
            <Route index element={<ServicePage />} />
            <Route
              path="detail/:id"
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <ServiceDetails />
                </Suspense>
              }
            />
          </Route>
          {/* //====================================================== */}

          <Route path="blogs">
            <Route index element={<Blogs />} />
            <Route
              path="detail/:id"
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <BlogDetail />
                </Suspense>
              }
            />
          </Route>

          {/*================== Footer================== */}
          <Route
            path="privacypolicy"
            element={
              <Suspense fallback={<SuspenseLoading />}>
                <PrivacyPolicy />
              </Suspense>
            }
          />

          <Route
            path="termsandconditions"
            element={
              <Suspense fallback={<SuspenseLoading />}>
                <TermsAndConditions />
              </Suspense>
            }
          />

          <Route
            path="imprint"
            element={
              <Suspense fallback={<SuspenseLoading />}>
                <Imprint />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
